module.exports = __webpack_public_path__ + "img/detail3.1f074172.png";